import { useEffect, useState } from 'react';

import { notify } from '../../shared';
import { Modal } from '../../components';
import { useRequest } from '../../hooks';
import { Button } from '../../components';
import { exportCampaign } from '../../api';
import { JsonView, Loading } from '../../components';
import { download, getErrorMessage } from '../../utilities';

type ExportModalProps = {
  campaignId: string;
  onClose: () => void;
};

const ExportModal: React.FC<ExportModalProps> = ({ campaignId, onClose }) => {
  const [exportData, setExportData] = useState<any>(null);

  const [handleExport, loading] = useRequest(
    (_signal, id: string) => {
      return exportCampaign(id);
    },
    {
      deps: [],
      onSuccess: data => {
        setExportData(data);
      },
      onError: ex => {
        notify.error(getErrorMessage(ex, 'Failed to export campaign'));
      },
    }
  );

  useEffect(() => {
    handleExport(campaignId);
  }, [campaignId, handleExport]);

  const handleDownload = () => {
    if (!exportData) return;

    const dataStr = JSON.stringify(exportData, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    download(dataBlob, `campaign-export-${campaignId}.json`);

    notify.success('Campaign exported successfully');
    onClose();
  };

  return (
    <Modal
      open
      size="big"
      title="Export Campaign"
      onClose={onClose}
      bottomActions={
        <>
          <Button
            type="primary"
            loading={loading}
            disabled={!exportData}
            onClick={handleDownload}
          >
            Download JSON
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </>
      }
    >
      <div className="flex flex-col gap-y-md">
        <div className="text-small text-text-muted">
          {loading ? <Loading /> : 'Campaign export ready'}
        </div>
        {exportData && <JsonView value={exportData}></JsonView>}
      </div>
    </Modal>
  );
};

export default ExportModal;
